import React, { FC, useEffect, useMemo } from 'react'
import { Button, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, useDisclosure } from '@chakra-ui/react'

import useGetProfessionalContractTypeByID from 'components/tools/CustomForm/components/Viewer/hooks/useGetProfessionalContractTypeByID'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import ProfessionalContractTypeCard from 'InstitutionalManagement/components/ProfessionalContractTypeCard'
import SearchProfessionalContractTypeOnCustomForm from './components/SearchProfessionalContractTypeOnCustomForm'
import SelectProfessionalContractTypeOnCustomForm from './components/SelectProfessionalContractTypeOnCustomForm'
import { useCustomFormProfessionalContractTypeSelectionDrawerManager } from './contexts/CustomFormProfessionalContractTypeSelectionDrawerManager/Provider'

type Views = {
  [key: string]: JSX.Element
}

type Props = {
  question: CustomFormQuestion
  disabled?: boolean
}

const CustomFormProfessionalContractTypeSelectionDrawerContent: FC<Props> = ({ question, disabled }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  const { getProfessionalContractType, loadingProfessionalContractType } = useGetProfessionalContractTypeByID()

  const { selectedProfessionalContractType, setSelectedProfessionalContractType, view, filter } =
    useCustomFormProfessionalContractTypeSelectionDrawerManager()

  const RenderComponent = useMemo(() => {
    const views: Views = {
      SEARCH_PROFESSIONAL_CONTRACT_TYPE: <SearchProfessionalContractTypeOnCustomForm onClose={onClose} />,
      SELECT_PROFESSIONAL_CONTRACT_TYPE: <SelectProfessionalContractTypeOnCustomForm onClose={onClose} />,
    }

    return views[view]
  }, [filter, view])

  async function loadProfessionalContractType(professionalContractTypeId: string) {
    const professionalContractTypeFromAPI = await getProfessionalContractType(professionalContractTypeId)
    setSelectedProfessionalContractType(professionalContractTypeFromAPI)
  }

  useEffect(() => {
    async function loadAsyncFunction() {
      if (question.default_value && question.default_value.length > 0) {
        const professionalContractTypeId = question.default_value[0]
        await loadProfessionalContractType(professionalContractTypeId)
      }
      if (question.answer && question.answer.length > 0) {
        const professionalContractTypeId = question.answer[0]
        await loadProfessionalContractType(professionalContractTypeId)
      }
    }
    loadAsyncFunction()
  }, [question])

  return (
    <>
      <Button
        isLoading={loadingProfessionalContractType}
        minWidth="100%"
        variant="outline"
        isDisabled={disabled}
        width="max-content"
        onClick={onOpen}
      >
        {selectedProfessionalContractType?.id ? 'Atualizar tipo de contrato' : 'Adicionar tipo de contrato'}
      </Button>

      {selectedProfessionalContractType?.id && (
        <ProfessionalContractTypeCard
          professionalContractType={selectedProfessionalContractType}
          borderWidth="1px"
          borderColor="borderColor"
        />
      )}

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />

          {RenderComponent}
        </DrawerContent>
      </Drawer>
    </>
  )
}

export default CustomFormProfessionalContractTypeSelectionDrawerContent
